/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {SummaryHealthInsurances} from './components/SummaryHealthInsurances'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { TranslateDOM } from '../../utils'

const DashboardPage: FC = () => {
  return (
    <>
      <SummaryHealthInsurances />
    </>
  )
}

const DashboardWrapper: FC = () => {
  const locale = useLang()
  const filterState = useSelector((state: RootState) => state.filter).RefreshDashboard

  useEffect(() => {
    if(filterState.refresh) window.location.reload()
    if(locale !== 'vi') {
      TranslateDOM()
    }
  }, [])

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
